var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocument = function SvgDocument(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    "data-width-72": 53,
    viewBox: "0 0 17.6 19.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.5 16.256V6.294a.8.8 0 0 0-.05-.308.7.7 0 0 0-.15-.23l-5-5.5a.74.74 0 0 0-.658-.25H3.25A3.26 3.26 0 0 0 0 3.256v13a3.26 3.26 0 0 0 3.25 3.25h11a3.26 3.26 0 0 0 3.25-3.25M3.25 1.506l7.75.038v4.712a.76.76 0 0 0 .75.75H16v9.25a1.76 1.76 0 0 1-1.75 1.75h-11a1.76 1.76 0 0 1-1.75-1.75v-13a1.76 1.76 0 0 1 1.75-1.75m11.797 4L12.5 2.726v2.78zm-10.297 9.5h8a.75.75 0 1 0 0-1.5h-8a.75.75 0 1 0 0 1.5",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export default ForwardRef;